export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11639.67656c64.jpg";